export interface Beneficiaria {
    id: string,
    nome: string,
	cnpj: string,
    objetoContrato: string;
    descricao: string,
    coligadaNovacap: boolean,
	responsaveis: any[]
}
